import { c as _c } from "react/compiler-runtime";
import { Ban, FileText, PackageCheck, ShieldAlert, Wallet } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { LEGAL_DOCS } from "@/lib/operator";

// Страница «Возврат» — требование банка-эквайера: как вернуть товар и деньги,
// сроки и способ возврата. Пересказ Правил возврата и обмена OSMIX (разд. 3-8),
// полный текст — PDF внизу и в подвале.
export function ReturnsPage() {
  const $ = _c(119);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] !== t) {
    t0 = t("returnsPage.good.title", {
      defaultValue: "\u0422\u043E\u0432\u0430\u0440 \u043D\u0435 \u043F\u043E\u0434\u043E\u0448\u0451\u043B"
    });
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("returnsPage.good.desc", {
      defaultValue: "\u041E\u0442 \u0442\u043E\u0432\u0430\u0440\u0430 \u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0435\u0433\u043E \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0430 \u043C\u043E\u0436\u043D\u043E \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0434\u043E \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0438 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 7 \u0434\u043D\u0435\u0439 \u043F\u043E\u0441\u043B\u0435. \u0415\u0441\u043B\u0438 \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u043D\u0435 \u0431\u044B\u043B \u043F\u0435\u0440\u0435\u0434\u0430\u043D \u0432\u0430\u043C \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E \u043F\u0440\u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0435, \u0441\u0440\u043E\u043A \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 3 \u043C\u0435\u0441\u044F\u0446\u0430. \u041D\u0443\u0436\u043D\u043E \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0442\u043E\u0432\u0430\u0440\u043D\u044B\u0439 \u0432\u0438\u0434, \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430, \u044F\u0440\u043B\u044B\u043A\u0438 \u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u043E\u043A\u0443\u043F\u043A\u0438, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0439 \u0447\u0435\u043A."
    });
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      key: "good",
      icon: PackageCheck,
      title: t0,
      desc: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("returnsPage.defect.title", {
      defaultValue: "\u0422\u043E\u0432\u0430\u0440 \u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043A\u043E\u043C"
    });
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("returnsPage.defect.desc", {
      defaultValue: "\u0415\u0441\u043B\u0438 \u0442\u043E\u0432\u0430\u0440 \u0441 \u0431\u0440\u0430\u043A\u043E\u043C \u0438\u043B\u0438 \u043D\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u044E, \u0432\u044B \u0432\u043F\u0440\u0430\u0432\u0435 \u043F\u043E\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u0437\u0430\u043C\u0435\u043D\u044B, \u0443\u043C\u0435\u043D\u044C\u0448\u0435\u043D\u0438\u044F \u0446\u0435\u043D\u044B, \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E\u0433\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043A\u0430 \u0438\u043B\u0438 \u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0434\u0435\u043D\u044C\u0433\u0438. \u0422\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0435 \u043C\u043E\u0436\u043D\u043E \u0437\u0430\u044F\u0432\u0438\u0442\u044C \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0439\u043D\u043E\u0433\u043E \u0441\u0440\u043E\u043A\u0430, \u0430 \u0435\u0441\u043B\u0438 \u043E\u043D \u043D\u0435 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D, \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 2 \u043B\u0435\u0442. \u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0443 \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u0442 \u043F\u0440\u043E\u0434\u0430\u0432\u0435\u0446."
    });
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = {
      key: "defect",
      icon: ShieldAlert,
      title: t3,
      desc: t4
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("returnsPage.exceptions.title", {
      defaultValue: "\u0427\u0442\u043E \u043D\u0435\u043B\u044C\u0437\u044F \u0432\u0435\u0440\u043D\u0443\u0442\u044C"
    });
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("returnsPage.exceptions.desc", {
      defaultValue: "\u0411\u0435\u0437 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043A\u043E\u0432 \u043D\u0435 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u044E\u0442\u0441\u044F \u0442\u043E\u0432\u0430\u0440\u044B \u0438\u0437 \u043F\u0435\u0440\u0435\u0447\u043D\u044F, \u0443\u0442\u0432\u0435\u0440\u0436\u0434\u0451\u043D\u043D\u043E\u0433\u043E \u041F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u0424: \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 \u043B\u0438\u0447\u043D\u043E\u0439 \u0433\u0438\u0433\u0438\u0435\u043D\u044B, \u043F\u0430\u0440\u0444\u044E\u043C\u0435\u0440\u0438\u044F \u0438 \u043A\u043E\u0441\u043C\u0435\u0442\u0438\u043A\u0430, \u0442\u043E\u0432\u0430\u0440\u044B \u043D\u0430 \u043C\u0435\u0442\u0440\u0430\u0436, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0432\u0435\u0449\u0438, \u0438\u0437\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u043D\u0430 \u0437\u0430\u043A\u0430\u0437 \u043F\u043E \u0432\u0430\u0448\u0438\u043C \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u043C \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043C."
    });
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = {
      key: "exceptions",
      icon: Ban,
      title: t6,
      desc: t7
    };
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t2 || $[22] !== t5 || $[23] !== t8) {
    t9 = [t2, t5, t8];
    $[21] = t2;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const cases = t9 as const;
  let t10;
  if ($[25] !== t) {
    t10 = t("returnsPage.steps.1", {
      defaultValue: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \xAB\u041C\u043E\u0438 \u0437\u0430\u043A\u0430\u0437\u044B\xBB \u0432 \u043B\u0438\u0447\u043D\u043E\u043C \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0435, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0437\u0430\u043A\u0430\u0437 \u0438 \u0442\u043E\u0432\u0430\u0440 \u0438 \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443 \u043D\u0430 \u0432\u043E\u0437\u0432\u0440\u0430\u0442: \u0443\u043A\u0430\u0436\u0438\u0442\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0438\u0442\u0435 \u0444\u043E\u0442\u043E, \u0435\u0441\u043B\u0438 \u0442\u043E\u0432\u0430\u0440 \u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043A\u043E\u043C."
    });
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t) {
    t11 = t("returnsPage.steps.2", {
      defaultValue: "\u041F\u0440\u043E\u0434\u0430\u0432\u0435\u0446 \u0440\u0430\u0441\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0435\u0442 \u0437\u0430\u044F\u0432\u043A\u0443 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 3 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0435\u0439 \u0438 \u043F\u0440\u0438\u0441\u044B\u043B\u0430\u0435\u0442 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044E: \u0430\u0434\u0440\u0435\u0441 \u0438 \u0441\u043F\u043E\u0441\u043E\u0431 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438."
    });
    $[27] = t;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t) {
    t12 = t("returnsPage.steps.3", {
      defaultValue: "\u041E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0442\u043E\u0432\u0430\u0440 \u0432 \u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0435\u0439 \u0443\u043F\u0430\u043A\u043E\u0432\u043A\u0435 \u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043E\u0431 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0434\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430."
    });
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t) {
    t13 = t("returnsPage.steps.4", {
      defaultValue: "\u0415\u0441\u043B\u0438 \u0441 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u043C \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u0442\u044C\u0441\u044F, \u043E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u0441\u043F\u043E\u0440: \u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0430 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0438\u0442 \u0435\u0433\u043E \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 10 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0435\u0439."
    });
    $[31] = t;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t13) {
    t14 = [t10, t11, t12, t13];
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  const steps = t14;
  let t15;
  if ($[38] !== t) {
    t15 = t("catalog.breadcrumbHome", {
      defaultValue: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F"
    });
    $[38] = t;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t15) {
    t16 = <Link to="/" className="hover:text-osmix-tangelo">{t15}</Link>;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t) {
    t17 = t("returnsPage.title", {
      defaultValue: "\u0412\u043E\u0437\u0432\u0440\u0430\u0442 \u0438 \u043E\u0431\u043C\u0435\u043D"
    });
    $[42] = t;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== t17) {
    t18 = <span className="text-[#1F1F1F]">{t17}</span>;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t16 || $[47] !== t18) {
    t19 = <nav aria-label={"\u0425\u043B\u0435\u0431\u043D\u044B\u0435 \u043A\u0440\u043E\u0448\u043A\u0438"} className="flex flex-wrap items-center gap-3 text-[14px] leading-[18px] text-black/50">{t16}{t18}</nav>;
    $[46] = t16;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t) {
    t20 = t("returnsPage.title", {
      defaultValue: "\u0412\u043E\u0437\u0432\u0440\u0430\u0442 \u0438 \u043E\u0431\u043C\u0435\u043D"
    });
    $[49] = t;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== t20) {
    t21 = <h1 className="type-h1-bold">{t20}</h1>;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== t) {
    t22 = t("returnsPage.intro", {
      defaultValue: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C \u0442\u043E\u0432\u0430\u0440 \u0438 \u0434\u0435\u043D\u044C\u0433\u0438 \u043C\u043E\u0436\u043D\u043E \u043F\u043E \u0417\u0430\u043A\u043E\u043D\u0443 \xAB\u041E \u0437\u0430\u0449\u0438\u0442\u0435 \u043F\u0440\u0430\u0432 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0435\u0439\xBB. \u0417\u0430\u044F\u0432\u043A\u0430 \u043E\u0444\u043E\u0440\u043C\u043B\u044F\u0435\u0442\u0441\u044F \u0432 \u043B\u0438\u0447\u043D\u043E\u043C \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0435, \u0434\u0435\u043D\u044C\u0433\u0438 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u044E\u0442\u0441\u044F \u0442\u0435\u043C \u0436\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C, \u043A\u043E\u0442\u043E\u0440\u044B\u043C \u0432\u044B \u043F\u043B\u0430\u0442\u0438\u043B\u0438."
    });
    $[53] = t;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== t22) {
    t23 = <p className="max-w-2xl type-body1 text-osmix-text-2">{t22}</p>;
    $[55] = t22;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== t21 || $[58] !== t23) {
    t24 = <div className="flex flex-col gap-2">{t21}{t23}</div>;
    $[57] = t21;
    $[58] = t23;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== t19 || $[61] !== t24) {
    t25 = <div className="flex flex-col gap-6">{t19}{t24}</div>;
    $[60] = t19;
    $[61] = t24;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== cases) {
    t26 = <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{cases.map(_temp)}</div>;
    $[63] = cases;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] !== t) {
    t27 = t("returnsPage.stepsTitle", {
      defaultValue: "\u041A\u0430\u043A \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u0432\u043E\u0437\u0432\u0440\u0430\u0442"
    });
    $[65] = t;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== t27) {
    t28 = <h2 className="type-h2">{t27}</h2>;
    $[67] = t27;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  let t29;
  if ($[69] !== steps) {
    t29 = <ol className="flex max-w-3xl flex-col gap-3">{steps.map(_temp2)}</ol>;
    $[69] = steps;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  let t30;
  if ($[71] !== t) {
    t30 = t("returnsPage.ordersLink", {
      defaultValue: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u043C\u043E\u0438\u043C \u0437\u0430\u043A\u0430\u0437\u0430\u043C"
    });
    $[71] = t;
    $[72] = t30;
  } else {
    t30 = $[72];
  }
  let t31;
  if ($[73] !== t30) {
    t31 = <Link to="/profile/orders" className="w-fit type-body1 text-osmix-tangelo hover:underline">{t30}</Link>;
    $[73] = t30;
    $[74] = t31;
  } else {
    t31 = $[74];
  }
  let t32;
  if ($[75] !== t28 || $[76] !== t29 || $[77] !== t31) {
    t32 = <section className="flex flex-col gap-4">{t28}{t29}{t31}</section>;
    $[75] = t28;
    $[76] = t29;
    $[77] = t31;
    $[78] = t32;
  } else {
    t32 = $[78];
  }
  let t33;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Wallet className="size-6 shrink-0 text-osmix-tangelo" strokeWidth={1.5} />;
    $[79] = t33;
  } else {
    t33 = $[79];
  }
  let t34;
  if ($[80] !== t) {
    t34 = t("returnsPage.money.title", {
      defaultValue: "\u0412\u043E\u0437\u0432\u0440\u0430\u0442 \u0434\u0435\u043D\u0435\u0433"
    });
    $[80] = t;
    $[81] = t34;
  } else {
    t34 = $[81];
  }
  let t35;
  if ($[82] !== t34) {
    t35 = <h2 className="type-body1-bold text-osmix-text-1">{t34}</h2>;
    $[82] = t34;
    $[83] = t35;
  } else {
    t35 = $[83];
  }
  let t36;
  if ($[84] !== t) {
    t36 = t("returnsPage.money.term", {
      defaultValue: "\u0414\u0435\u043D\u044C\u0433\u0438 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u044E\u0442\u0441\u044F \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 10 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u044B\u0445 \u0434\u043D\u0435\u0439 \u043F\u043E\u0441\u043B\u0435 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A \u043F\u0440\u043E\u0434\u0430\u0432\u0435\u0446 \u0438\u043B\u0438 \u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u043B\u0438 \u0432\u043E\u0437\u0432\u0440\u0430\u0442."
    });
    $[84] = t;
    $[85] = t36;
  } else {
    t36 = $[85];
  }
  let t37;
  if ($[86] !== t36) {
    t37 = <li>{t36}</li>;
    $[86] = t36;
    $[87] = t37;
  } else {
    t37 = $[87];
  }
  let t38;
  if ($[88] !== t) {
    t38 = t("returnsPage.money.way", {
      defaultValue: "\u041E\u043F\u043B\u0430\u0442\u0430 \u043A\u0430\u0440\u0442\u043E\u0439 - \u043D\u0430 \u0442\u0443 \u0436\u0435 \u043A\u0430\u0440\u0442\u0443, \u043F\u043E \u0421\u0411\u041F - \u043D\u0430 \u0441\u0447\u0451\u0442, \u0441 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u043F\u0440\u043E\u0448\u0451\u043B \u043F\u043B\u0430\u0442\u0451\u0436, \u043F\u043E \u0441\u0447\u0451\u0442\u0443 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 - \u043D\u0430 \u0440\u0430\u0441\u0447\u0451\u0442\u043D\u044B\u0439 \u0441\u0447\u0451\u0442 \u043F\u043B\u0430\u0442\u0435\u043B\u044C\u0449\u0438\u043A\u0430."
    });
    $[88] = t;
    $[89] = t38;
  } else {
    t38 = $[89];
  }
  let t39;
  if ($[90] !== t38) {
    t39 = <li>{t38}</li>;
    $[90] = t38;
    $[91] = t39;
  } else {
    t39 = $[91];
  }
  let t40;
  if ($[92] !== t) {
    t40 = t("returnsPage.money.delivery", {
      defaultValue: "\u0415\u0441\u043B\u0438 \u0442\u043E\u0432\u0430\u0440 \u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043A\u043E\u043C, \u043D\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D \u0432 \u0441\u0440\u043E\u043A \u0438\u043B\u0438 \u0432\u044B \u043D\u0435 \u0432\u044B\u043A\u0443\u043F\u0438\u043B\u0438 \u0437\u0430\u043A\u0430\u0437, \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442\u0441\u044F \u0432\u0441\u044F \u0441\u0443\u043C\u043C\u0430, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0443."
    });
    $[92] = t;
    $[93] = t40;
  } else {
    t40 = $[93];
  }
  let t41;
  if ($[94] !== t40) {
    t41 = <li>{t40}</li>;
    $[94] = t40;
    $[95] = t41;
  } else {
    t41 = $[95];
  }
  let t42;
  if ($[96] !== t) {
    t42 = t("returnsPage.money.bank", {
      defaultValue: "\u0421\u0440\u043E\u043A \u0437\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0431\u0430\u043D\u043A\u0430 \u0438 \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u0434\u043E 30 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u044B\u0445 \u0434\u043D\u0435\u0439."
    });
    $[96] = t;
    $[97] = t42;
  } else {
    t42 = $[97];
  }
  let t43;
  if ($[98] !== t42) {
    t43 = <li>{t42}</li>;
    $[98] = t42;
    $[99] = t43;
  } else {
    t43 = $[99];
  }
  let t44;
  if ($[100] !== t37 || $[101] !== t39 || $[102] !== t41 || $[103] !== t43) {
    t44 = <ul className="flex list-disc flex-col gap-1 pl-5 type-body2 text-osmix-text-2">{t37}{t39}{t41}{t43}</ul>;
    $[100] = t37;
    $[101] = t39;
    $[102] = t41;
    $[103] = t43;
    $[104] = t44;
  } else {
    t44 = $[104];
  }
  let t45;
  if ($[105] !== t35 || $[106] !== t44) {
    t45 = <section className="flex gap-3 rounded-[16px] bg-osmix-tangelo/5 p-5">{t33}<div className="flex flex-col gap-2">{t35}{t44}</div></section>;
    $[105] = t35;
    $[106] = t44;
    $[107] = t45;
  } else {
    t45 = $[107];
  }
  let t46;
  if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <FileText className="size-5" />;
    $[108] = t46;
  } else {
    t46 = $[108];
  }
  let t47;
  if ($[109] !== t) {
    t47 = t("returnsPage.rulesPdf", {
      defaultValue: "\u041F\u043E\u043B\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u0438 \u043E\u0431\u043C\u0435\u043D\u0430 (PDF)"
    });
    $[109] = t;
    $[110] = t47;
  } else {
    t47 = $[110];
  }
  let t48;
  if ($[111] !== t47) {
    t48 = <a href={LEGAL_DOCS.returns} target="_blank" rel="noreferrer" className="flex w-fit items-center gap-2 rounded-[12px] bg-osmix-text-1 px-5 py-3 type-button text-white outline-none transition-colors hover:bg-osmix-text-1/90 focus-visible:ring-2 focus-visible:ring-osmix-tangelo/40">{t46}{t47}</a>;
    $[111] = t47;
    $[112] = t48;
  } else {
    t48 = $[112];
  }
  let t49;
  if ($[113] !== t25 || $[114] !== t26 || $[115] !== t32 || $[116] !== t45 || $[117] !== t48) {
    t49 = <div className="flex flex-col gap-8">{t25}{t26}{t32}{t45}{t48}</div>;
    $[113] = t25;
    $[114] = t26;
    $[115] = t32;
    $[116] = t45;
    $[117] = t48;
    $[118] = t49;
  } else {
    t49 = $[118];
  }
  return t49;
}
function _temp2(step, i) {
  return <li key={step} className="flex gap-3 type-body1 text-osmix-text-1"><span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-osmix-tangelo/10 type-body2 font-semibold text-osmix-tangelo">{i + 1}</span><span className="pt-0.5">{step}</span></li>;
}
function _temp(c) {
  return <section key={c.key} className="flex flex-col gap-3 rounded-[16px] bg-[#F8F8F8] p-5"><span className="flex size-11 items-center justify-center rounded-[12px] bg-white text-osmix-tangelo"><c.icon className="size-6" strokeWidth={1.5} /></span><h2 className="type-h5 text-osmix-text-1">{c.title}</h2><p className="type-body2 text-osmix-text-2">{c.desc}</p></section>;
}